export default class fullSlide {

    static init() {

        $("#open-menu").on("click", function() {
            // Data Link
            $(this).toggleClass('active');
            $('.main-menu').toggleClass('open');
        });

    }

}